/**
 *
 */
export enum TemperatureUnit {
    Celsius = "celsius",
    Fahrenheit = "fahrenheit",
    Kelvin = "kelvin",
}